import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["questionType", "scaleMin", "scaleMax", "scaleFields", "surveyType"]

  connect() {
    // Auto-fill on page load if survey_type already selected
    this.typeChanged()
  }

  typeChanged(event) {
    const surveyType = event?.target?.value || this.surveyTypeTarget?.value || ''

    switch(surveyType) {
      case 'nps':
        this.setFields('scale', 0, 10, true)
        break
      case 'csat':
        this.setFields('scale', 1, 5, true)
        break
      case 'text':
        this.setFields('text', null, null, false)
        break
      default:
        this.resetFields()
    }
  }

  setFields(questionType, min, max, showScale) {
    // Set question_type
    if (this.hasQuestionTypeTarget) {
      this.questionTypeTarget.value = questionType
      // Only disable if it's a select/visible field (not hidden)
      if (this.questionTypeTarget.type !== 'hidden') {
        this.questionTypeTarget.disabled = true
      }
    }

    // Set scale fields
    if (this.hasScaleMinTarget && this.hasScaleMaxTarget) {
      this.scaleMinTarget.value = min !== null ? min : ''
      this.scaleMaxTarget.value = max !== null ? max : ''
      this.scaleMinTarget.readOnly = true
      this.scaleMaxTarget.readOnly = true
    }

    // Show/hide scale fields
    if (this.hasScaleFieldsTarget) {
      this.scaleFieldsTarget.style.display = showScale ? 'block' : 'none'
    }
  }

  resetFields() {
    if (this.hasQuestionTypeTarget) {
      this.questionTypeTarget.value = ''
      this.questionTypeTarget.disabled = false
    }

    if (this.hasScaleMinTarget && this.hasScaleMaxTarget) {
      this.scaleMinTarget.value = ''
      this.scaleMaxTarget.value = ''
      this.scaleMinTarget.readOnly = false
      this.scaleMaxTarget.readOnly = false
    }

    if (this.hasScaleFieldsTarget) {
      this.scaleFieldsTarget.style.display = 'none'
    }
  }
}
